export function formatTimeAgo(timestamp) {
  if (!timestamp) return "3 years ago";
  try {
    const now = new Date();
    const date = new Date(timestamp);
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) {
      return "just now";
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} ${
        diffInMinutes === 1 ? "minute" : "minutes"
      } ago`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} ${diffInHours === 1 ? "hour" : "hours"} ago`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays} ${diffInDays === 1 ? "day" : "days"} ago`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} ${diffInMonths === 1 ? "month" : "months"} ago`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} ${diffInYears === 1 ? "year" : "years"} ago`;
  } catch (e) {
    console.error("Error formatting relative time:", e);
    return "3 years ago";
  }
}

export function formatStartDate(timestamp) {
  if (!timestamp) return "2/2/2024 2:31 AM EST";
  try {
    const date = new Date(timestamp);
    const options = {
      timeZone: "America/New_York",
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };

    let formatted = new Intl.DateTimeFormat("en-US", options).format(date);
    const isEDT = date
      .toLocaleTimeString("en-US", { timeZone: "America/New_York" })
      .includes("Daylight");
    const timeZoneLabel = isEDT ? "EDT" : "EST";
    return formatted + " " + timeZoneLabel;
  } catch (e) {
    console.error("Error formatting date:", e);
    return "2/2/2024 2:31 AM EST";
  }
}

export function formatDate(timestamp, type = "startDate") {
  if (type === "timeAgo") {
    return formatTimeAgo(timestamp);
  } else if (type === "startDate") {
    return formatStartDate(timestamp);
  } else {
    console.warn(
      `Unknown date format type: ${type}, defaulting to startDate format`
    );
    return formatStartDate(timestamp);
  }
}